/**
 * @module media/mediaresize
 */
import { Plugin } from '@ckeditor/ckeditor5-core';
import MediaResizeEditing from "./mediaresize/mediaresizeediting";
import MediaResizeButtons from "./mediaresize/mediaresizebuttons";
import './theme/mediaresize.css';

export default class MediaResize extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [MediaResizeEditing, MediaResizeButtons];
    }
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'MediaResize';
    }
}
//# sourceMappingURL=mediaresize.js.map